import { render, staticRenderFns } from "./BuildingListNewExist.vue?vue&type=template&id=39327453&scoped=true&"
import script from "./BuildingListNewExist.vue?vue&type=script&lang=js&"
export * from "./BuildingListNewExist.vue?vue&type=script&lang=js&"
import style0 from "./BuildingListNewExist.vue?vue&type=style&index=0&id=39327453&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39327453",
  null
  
)

export default component.exports